import React from 'react';
import { SelectInput } from 'react-admin';
import { getClassificationFromSource } from '../PositionRateSettingsForm.utils';
import { useRateCalculations } from '../hooks/useRateCalculations';

type Props = {
  source: string;
  inheritedSettings: any;
};

export const RateStructureSelect = ({ source, inheritedSettings }: Props) => {
  const { level } = getClassificationFromSource(source);
  const { handlers } = useRateCalculations({ source, inheritedSettings });

  function onChangeRateStructure(event: React.ChangeEvent<HTMLInputElement>) {
    const selectedValue = event.target.value as unknown as boolean;

    handlers.handleRateStructureChange(selectedValue, level);
  }

  return (
    <SelectInput
      source={`${source}.use_blended_rate`}
      choices={[
        { id: false, name: '8 hour rate' },
        { id: true, name: '12 hour rate' },
      ]}
      label="Rate Structure"
      emptyText="Apply inheritance"
      onChange={onChangeRateStructure}
    />
  );
};
